// @ts-expect-error no valid declaration file available
import Popover from 'bootstrap/js/src/popover';
// @ts-expect-error no valid declaration file available
import Toast from 'bootstrap/js/src/toast';
// @ts-expect-error no valid declaration file available
import Tooltip from 'bootstrap/js/src/tooltip';

function activateInformationItems(): void {
  document.querySelectorAll('[data-bs-toggle="popover"]:not(.popover-initiated)').forEach((popoverTriggerElement) => {
    popoverTriggerElement.classList.add('popover-initiated');
    (popoverTriggerElement as HTMLElement & { rbbPopover: Popover }).rbbPopover = new Popover(popoverTriggerElement, {});
  });

  document.querySelectorAll('[data-bs-toggle="tooltip"]:not(.tooltip-initiated)').forEach((tooltipTriggerElement) => {
    tooltipTriggerElement.classList.add('tooltip-initiated');
    (tooltipTriggerElement as HTMLElement & { rbbTooltip: Tooltip }).rbbTooltip = new Tooltip(tooltipTriggerElement, {});
  });

  document.querySelectorAll('div.tooltip[role="tooltip"]').forEach((tooltipElement) => {
    if (tooltipElement) {
      const referenceElement = document.querySelector('[aria-describedby="' + tooltipElement.id + '"]');
      if (!referenceElement || window.getComputedStyle(referenceElement).display === 'none') {
        tooltipElement.remove();
      }
    }
  });

  document.querySelectorAll('div.popover[role="tooltip"]').forEach((popoverElement) => {
    if (popoverElement) {
      const referenceElement = document.querySelector('[aria-describedby="' + popoverElement.id + '"]');
      if (!referenceElement) {
        popoverElement.remove();
      }
    }
  });

  document.querySelectorAll('.toast:not(.toast-initiated)').forEach((toastElement) => {
    toastElement.classList.add('toast-initiated');
    toastElement.ariaLive = 'assertive';
    toastElement.ariaAtomic = 'true';
    toastElement.role = 'alert';
    (toastElement as HTMLElement & { toast: Toast }).toast = new Toast(toastElement);
    (toastElement as HTMLElement & { toast: Toast }).toast.show();
  });

  document.querySelectorAll('div.alert:not([role])').forEach(
    alert => alert.role = 'alert'
  );

  document.querySelectorAll('div.modal:not([role])').forEach(
    (modal) => {
      modal.role = 'dialog';
      (modal as HTMLElement).tabIndex = -1;
    }
  );

  document.querySelectorAll('div.modal-dialog:not([role])').forEach(
    (modal) => {
      modal.role = 'document';
    }
  );

  document.querySelectorAll('div.progress-bar:not([role])').forEach(
    (modal) => {
      modal.role = 'progressbar';
    }
  );

  document.querySelectorAll('.badge:not([role])').forEach(
    (modal) => {
      modal.role = 'status';
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  activateInformationItems();
  new MutationObserver(activateInformationItems).observe(document, { childList: true, subtree: true });
});
